import { render, staticRenderFns } from "./ViewSchool.vue?vue&type=template&id=f0443742&scoped=true"
import script from "./ViewSchool.vue?vue&type=script&lang=js"
export * from "./ViewSchool.vue?vue&type=script&lang=js"
import style0 from "./ViewSchool.vue?vue&type=style&index=0&id=f0443742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0443742",
  null
  
)

export default component.exports